import React, {useEffect, useState} from "react";

import {TouchableOpacity, View, Text, Image, StyleSheet} from "react-native";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import {Button} from "../../../components/core/Button";
import RadioButton from "../../../commonComponents/RadioButton";
import QrCode from "./QRCode";
import { globalImport } from "../../../common/globalImports";
import { isMobile } from "../../../utils/commonMethods";
import {globalConfigurableData} from "../../../utils/globalConstant";

const OnMetaPaymentFlow = ({paymentOptionList = [], onMetaMoneyAdd}) => {
  const [seletedIndex, setSelectedIndex] = useState("");
  const isDesktop = !isMobile();

  return (
    <View style={{width: Width.width - 20}}>
      <Text
        style={{
          ...globalFontStyle.appFontTitle,
          color: globalConfigurableData.quaternaryTextColor1,
          marginVertical: 15,
        }}>
        Choose Payment Method
      </Text>
      {isDesktop ? (
        <View style={{alignItems: "center"}}>
          <QrCode paymentOptionList={paymentOptionList[4].url} />
        </View>
      ) : (
        paymentOptionList.map((item, index) => {
          const isSelected = seletedIndex === index;
          return (
            <TouchableOpacity
              //style={{flexDirection: 'row'}}
              style={[styles.radioOuterBox]}
              activeOpacity={0.8}
              key={item.name}
              onPress={() => {
                setSelectedIndex(index);
              }}>
              <View style={{flexDirection: "row", alignItems: "center"}}>
                <FastImage
                  style={{width: 30, height: 30}}
                  source={item?.imageUrl}
                />

                <Text style={{marginLeft: 10}}>{item?.name}</Text>
              </View>

              <RadioButton
                isSelected={isSelected}
                btnColor={Colors.tradexBlue}
              />
            </TouchableOpacity>
          );
        })
      )}

      <Button
        variant="primary"
        onPress={() => {
          onMetaMoneyAdd(
            isDesktop ? "" : paymentOptionList[seletedIndex].url,
            isDesktop,
          );
        }}
        style={{flex: globalImport.isWeb ? {} : 0, marginVertical: 15}}
      >
        {isDesktop ? "Payment Completed" : "Add Money"}
      </Button>
    </View>
  );
};

export default OnMetaPaymentFlow;

const styles = StyleSheet.create({
  categoryImage: {
    width: 11,
    height: 11,
    marginRight: 6,
  },
  radioOuterBox: {
    flexDirection: "row",
    marginBottom: 16,
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 12,
    alignItems: "center",
    borderColor: "rgba(134, 134, 133, 1)",
    borderWidth: 1,
    justifyContent: "space-between",
    //flex: 1,
    width: Width.width - 20,
  },
});
